<div id="client-authorization-section">
  <ng-container *ngIf="displayAuthorizationTitle(); then eauth_tableHeader; else mmIneligibleAccountPageHeader"></ng-container>
  <ng-template #eauth_tableHeader>
    <span class="section-title"> Client authorization details</span>
  </ng-template>
  <ng-template #mmIneligibleAccountPageHeader>
    <span class="section-title"> {{mmIneligibleAccountPageHeaderText}} </span>
  </ng-template>
  <ng-container *ngIf="!eAuthServiceError; then eauth_status else service_error"> </ng-container>
  <ng-template #eauth_status>
    <div id="eauth_status">
      <ng-container
        *ngIf="shouldDisplayEauthTable then eauth_table else mmIneligibleAccountPage">
      </ng-container>
      <ng-template #eauth_table>
        <div id="clientAuthorization_eauthTableSection">
          <div id="clientAuthorization_eauthTableLabel">
            <span [class.is-invalid]="eAuthError$ | async">{{clientAuthorizationDetailsVerbiage}}
              <mm-tooltip [position]="'bottom'" [textTooltip]="true" [containsLink]="false"
                id="clientAuthorizationEauth_Tooltip">
                <tooltip-content>
                  <span [innerText]="clientEauthTooltipText"></span>
                </tooltip-content>
                <tooltip-trigger-element>
                  eAuthorization.
                </tooltip-trigger-element>
              </mm-tooltip>
              They'll receive a notification to approve the transaction details in
              <mm-tooltip [position]="'bottom'" [textTooltip]="true" [containsLink]="false"
                id="clientAuthorizationEauth_Tooltip">
                <tooltip-content>
                  <span [innerText]="schwabAllianceTooltipText"></span>
                </tooltip-content>
                <tooltip-trigger-element>
                  Schwab Alliance.
                </tooltip-trigger-element>
              </mm-tooltip>
            </span>
          </div>
          <mm-eauth-table [showSubmitEmailAddressButton]="showSubmitEmailAddressButton" [standingAuthorizationsEAuth]="standingAuthorizationsEAuth" [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable" [isPalAccount]="isPalAccount"></mm-eauth-table>
        </div>
      </ng-template>
      <ng-template #mmIneligibleAccountPage>
        <mm-ineligible-account *ngIf="!((isOneTimeTotalDist || isChecksBundledOneTimeTotalDist) && confirmationPagePhase2)" [eAuthClientsResponse]="eAuthClientsResponse" [transactionType]="transactionType"></mm-ineligible-account>
        <mm-label-group *ngIf="(isOneTimeTotalDist || isChecksBundledOneTimeTotalDist) && confirmationPagePhase2" id="confirmationPage_useEauthorizationLabel"  class="prefilled-text"  [data]="eAuthTextD2P"></mm-label-group>
      </ng-template>
      </div>
    </ng-template>
    <ng-template #service_error>
      <div id="eauth-service-error" class="eauth-service-error">
        <sdps-icon id="warning-icon" color="warning" type="functional" name="warning" size="small"
          data-testid="warning-icon"></sdps-icon>
        <span>{{eauthErrorText}}</span>
      </div>
    </ng-template>
  </div>
<div id="multipleItDetails_clientAuthBannerMessage" *ngIf="displayBanner">
  <mm-banners [htmlStr]="[clientAuthBannerMessageText]" class="client-authorization" [type]="'information'"
    [showCloseIcon]="false">
  </mm-banners>
</div>
